import { jsx } from 'react/jsx-runtime';
import { styled } from 'styled-components';
import { useQueryResourceTags } from '../../../../tags/queries/useQueryResourceTags.js';
import TagButton from '../../../../tags/components/TagButton.js';
import { resourceTagsModal } from '../../../../tags/components/ModalResourceTags/resourceTagsStore.js';

const TagButtonStyled = styled(TagButton).withConfig({
  displayName: "ModalExpandedResourceTagButton__TagButtonStyled",
  componentId: "sc-6d5b83a1-0"
})([
  `position:static;`
]);
const ModalExpandedResourceTagButton = ({ resourceId }) => {
  const queryResourceTags = useQueryResourceTags(resourceId);
  return /* @__PURE__ */ jsx(TagButtonStyled, {
    variant: "bg-secondary",
    selectedTags: queryResourceTags.data,
    onClick: () => resourceTagsModal.open({
      resourceId
    })
  });
};

export { ModalExpandedResourceTagButton };
//# sourceMappingURL=ModalExpandedResourceTagButton.js.map
